import { useCallback, useMemo } from 'react';
import { useAppDispatch, setAutoSavingStatus } from 'src/store';
import { AutoSavingStatus } from 'src/types';

export const useEditorAutoSavingStatus = () => {
  const dispatch = useAppDispatch();

  const onChangeAutoSavingStatus = useCallback(
    (status: AutoSavingStatus | null) => {
      dispatch(setAutoSavingStatus(status));
    },
    [dispatch],
  );

  return useMemo(
    () => ({
      onChangeAutoSavingStatus,
    }),
    [onChangeAutoSavingStatus],
  );
};
